// Named imports so the bundler only ships the icons we use; importing lucide's full `icons` map pulls
// all ~2000 in. Keys are the kebab-case names from config/resource_chips.yml — resource_chip_spec
// fails if the YAML gains an icon this map doesn't cover.
import {
  ArrowLeftRight,
  BarChart2,
  Barcode,
  Brain,
  ChartColumnBig,
  Clock,
  Compass,
  CreditCard,
  Download,
  FileText,
  FileUp,
  FolderOpen,
  Globe,
  Hash,
  Image,
  Info,
  LayoutDashboard,
  LifeBuoy,
  List,
  Mail,
  MapPin,
  MessageCircleQuestion,
  MessageSquareText,
  Package,
  Phone,
  PhoneCall,
  ShieldCheck,
  ShoppingCart,
  Ticket,
  User,
  Users,
} from "lucide";

export const RESOURCE_ICONS = {
  "arrow-left-right": ArrowLeftRight,
  "bar-chart-2": BarChart2,
  barcode: Barcode,
  brain: Brain,
  "chart-column-big": ChartColumnBig,
  clock: Clock,
  compass: Compass,
  "credit-card": CreditCard,
  download: Download,
  "file-text": FileText,
  "file-up": FileUp,
  "folder-open": FolderOpen,
  globe: Globe,
  hash: Hash,
  image: Image,
  info: Info,
  "layout-dashboard": LayoutDashboard,
  "life-buoy": LifeBuoy,
  list: List,
  mail: Mail,
  "map-pin": MapPin,
  "message-circle-question": MessageCircleQuestion,
  "message-square-text": MessageSquareText,
  package: Package,
  phone: Phone,
  "phone-call": PhoneCall,
  "shield-check": ShieldCheck,
  "shopping-cart": ShoppingCart,
  ticket: Ticket,
  user: User,
  users: Users,
};
